module.exports = __webpack_public_path__ + "site/img/index3-newyear.8da6b847.png";